import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { motion } from 'framer-motion';
const variants = {
    blue: 'bg-blue',
    green: 'bg-green',
    gold: 'bg-gold',
    red: 'bg-red',
};
const DesktopNavigationButton = ({ route, active, onClick, }) => {
    const bgClasses = classNames('absolute inset-0 bg-grey-50 transition-opacity duration-500', active ? 'opacity-0' : 'opacity-100');
    const buttonClasses = classNames('relative z-10 text-body-small font-semibold px-6 py-2.5 transition-colors duration-500 focus:outline-green', active ? 'text-white' : 'text-green-600');
    return (_jsxs("div", { className: "relative", children: [_jsx("div", { className: bgClasses }), active && (_jsx(motion.div, { className: `absolute inset-0 z-10 ${variants[route.meta.variant]}`, layoutId: "desktop-nav-active" })), _jsx("button", { className: buttonClasses, onClick: onClick, children: route.meta.title })] }));
};
const DesktopNavigation = ({ nav }) => {
    return (_jsx("div", { className: "flex justify-center", children: _jsx("div", { className: "relative flex bg-white pointer-events-auto p-1.5 space-x-1.5", children: nav.routes.map((route) => (_jsx(DesktopNavigationButton, { route: route, active: nav.match(route), onClick: () => nav.setRoute(route) }, route.path))) }) }));
};
export default DesktopNavigation;
